import {useState, useContext, createContext} from "react"
import translations from "./translations.json"
import {ComponentProps, Content} from "./types"
import {useSearchParams} from "react-router-dom"
import {getValue} from "./helpers";

const contextDefaultValues: Content = {
  lang: "fi",
  translations: translations["fi"]
}

const ContentContext: React.Context<Content> = createContext(contextDefaultValues)

const useContentContext = () => useContext<Content>(ContentContext)

const ContentProvider = (props: ComponentProps) => {
  const [searchParams] = useSearchParams()
  const lang = searchParams.get("lang") ?? "fi"
  
  const [content, setContent] = useState<any>({
    lang: lang,
    translations: getValue(lang, translations)
  })

  return (
    <ContentContext.Provider value={{...content}}>
      {props.children}
    </ContentContext.Provider>
  );
}

export {ContentContext, ContentProvider, useContentContext}
